export default {
    computed: {
        headers() {
            return [
                {
                    value: 'id',
                    text: this.$t('labels.identifier'),
                },
                {
                    value: 'name',
                    text: this.$t('labels.name'),
                    type: 'string',
                },
            ]
        },
    },
}
